namespace TabAurous.RateHelper {

    export interface RateAttributes {
        ProductTypeId?: number;
        CategoryId?: number;
        SubCategoryId?: number;
        ShapeId?: number;
        SieveId?: number;
        GroupSieveId?: number;
        StoneSizeId?: number;
        StoneColorId?: number;
        QualityId?: number;
        RateListId?: number;
        ProductId?: number;
        CostMethodId?: number;
        Weight?: number;
    }

    export interface LaborCalOptions {
        ProductId: number;
        AttributeId: number;
        RateListId?: number;
        Markup?: number;
        Pieces: number;
        Parts?: number;
        Weight: number;        
        NetWeight: number;
        DiamondWeight?: number;
        StoneWeight?: number;
        DiamondPieces?: number;
        StonePieces?: number;
        TransDate?: Date;
        IsWastage?: boolean;
        SettingId?: number;
        IsCustomerItem?: boolean;
    }


    export function GetPurchseLabour(options: LaborCalOptions) {

        let LaborRate = 0;
        let LRate = 0;
        let labordetail = [];
        let ItemLabor: any;
        let ATBDetails: OMS.CommonAttributesRow;
        let PurchaseLabor: Purchase.PurchaseLaborRow;

        OMS.CommonAttributesService.Retrieve({ EntityId: options.AttributeId }, response => ATBDetails = response.Entity, { async: false });
         
        let Key = ATBDetails.ItemTypeId == 101 ? 1002 : 1028;
        let LabourConfig = (GetConfigValue(Key)); 

        let LabourATBType = parseInt(LabourConfig) || 1; // set this using global config

        try {

            OMS.LabourMasterService.GetLaborRate(
                {
                    LaborMode: LabourATBType,
                    AttributeId: options.AttributeId,
                    PriceListId: options.RateListId,
                    SettingId: options.SettingId,
                    Weight: options.Weight,
                    Pieces: options.Pieces,
                    Parts: options.Parts
                },
                response => ItemLabor = response.Entities,
                {
                    async: false
                }
            );
            let x = ItemLabor;

            if (ItemLabor != null)
                ItemLabor.forEach(function (x) {
                    let LProcessID = x.ProcessId;
                    let LProcess = OMS.ProcessMasterRow.getLookup().itemById[LProcessID]
                    if (!options.IsWastage && LProcess.ProcessCode.toUpperCase() != "WASTAGE") {
                        let LaborPrdDetails: OMS.ProductMasterRow;
                        OMS.ProductMasterService.Retrieve({ EntityId: options.ProductId },
                            response => LaborPrdDetails = response.Entity, { async: false });
                        let LRateType = x.RateType;
                        let LRate = 0;

                        //let CalcOn = OMS.FixedCodeRow.getLookup().itemById[LProcess.CalcOnId].FixedCode;

                        if (LRateType == 1) {
                            let MetalRate = OMS.MetalRateMasterRow.getLookup().items.filter(z => z.MetalTypeId == LaborPrdDetails.MetalId
                                && z.RateTypeId == 33 && z.CompanyId == Q.Authorization.userDefinition.CompanyId)[0].Rate
                            if (options.RateListId > 0)
                                LRate = options.Markup > 0 ? MetalRate * (x.Amount / 100) * options.Markup : MetalRate * (x.Amount / 100);
                            else
                                LRate = MetalRate * (x.PurStdLabour / 100);
                        }
                        else {

                            if (options.RateListId > 0)
                                LRate = options.Markup > 0 ? x.Amount * options.Markup : x.Amount;
                            else
                                LRate = options.Markup > 0 ? x.PurStdLabour * options.Markup : x.PurStdLabour;
                        }

                        let LAmount;
                        switch (x.CalcOnId) {
                            case 61:
                                LAmount = options.Pieces * LRate;
                                break;
                            case 62:
                                LAmount = options.NetWeight * LRate;
                                break;
                            case 63:
                                LAmount = options.Weight * LRate;
                                break;
                            case 64:
                                LAmount = options.DiamondWeight > 0 ? options.DiamondWeight * LRate : options.Weight * LRate;
                                break;
                            case 65:
                                LAmount = options.StoneWeight > 0 ? options.StoneWeight * LRate : options.Weight * LRate;
                                break;
                            case 66:
                                LAmount = options.Parts * LRate;
                                break;

                        }

                        LaborRate += LAmount;
                        if (LAmount < x.MinLabour) {
                            LAmount = x.MinLabour;
                            switch (x.CalcOnId) {
                                case 61:
                                    LRate = LAmount / options.Pieces * LRate;
                                    break;
                                case 62:
                                    LRate = options.NetWeight * LRate;
                                    break;
                                case 63:
                                    LRate = options.Weight * LRate;
                                    break;
                                case 64:
                                    LRate = options.DiamondWeight > 0 ? options.DiamondWeight * LRate : options.Weight * LRate;
                                    break;
                                case 65:
                                    LRate = options.StoneWeight > 0 ? options.StoneWeight * LRate : options.Weight * LRate;
                                    break;
                                case 66:
                                    LAmount = options.Parts * LRate;
                                    break;
                            }
                        }
                        PurchaseLabor=
                        {
                            ItemTypeId: LaborPrdDetails.ItemTypeId,
                            ProductTypeName: LaborPrdDetails.ProductTypeName,
                            ProductTypeId: LaborPrdDetails.ProductTypeId,
                            Attribute: LaborPrdDetails.Attribute,
                            AttributeId: x.AttributeId,
                            ProcessId: LProcessID,
                            Pieces: options.Pieces,
                            Weight: options.Weight,
                            Parts: options.Parts,
                            CalcOnId: x.CalcOnId,
                            ProcessName: LProcess.ProcessName,
                            LabourRate: LRate,
                            LabourAmount: LAmount,
                            CategoryId: ATBDetails.CategoryId,
                            SubCategoryId: ATBDetails.SubCategoryId,
                            QualityId: ATBDetails.QualityId,
                            ShapeId: ATBDetails.ShapeId,
                            StoneSizeId: ATBDetails.StoneSizeId,
                            SieveId: ATBDetails.SieveId,
                            StoneColorId: ATBDetails.StoneColorId,
                            //IsCustomerItem: IsCutomerItem

                        }
                    }
                    else {
                        if (options.IsWastage && LProcess.ProcessCode.toUpperCase() == "WASTAGE") {
                            let LaborPrdDetails: OMS.ProductMasterRow;
                            OMS.ProductMasterService.Retrieve({ EntityId: options.ProductId },
                                response => LaborPrdDetails = response.Entity, { async: false });
                            let LRateType = x.RateType;
                            let LRate = 0;
                            let CalcOn = OMS.FixedCodeRow.getLookup().itemById[LProcess.CalcOnId].FixedCode;

                            if (options.RateListId > 0)
                                LRate = options.Markup > 0 ? x.Amount * options.Markup : x.Amount;
                            else
                                LRate = options.Markup > 0 ? x.PurStdLabour * options.Markup : x.PurStdLabour;

                            let LAmount;

                            switch (x.CalcOnId) {
                                case 61:
                                    LRate = LAmount / options.Pieces * LRate;
                                    break;
                                case 62:
                                    LRate = options.NetWeight * LRate;
                                    break;
                                case 63:
                                    LRate = options.Weight * LRate;
                                    break;
                                case 64:
                                    LRate = options.DiamondWeight > 0 ? options.DiamondWeight * LRate : options.Weight * LRate;
                                    break;
                                case 65:
                                    LRate = options.StoneWeight > 0 ? options.StoneWeight * LRate : options.Weight * LRate;
                                    break;
                            }



                            LaborRate += LAmount;
                            PurchaseLabor =
                            {
                                ItemTypeId: LaborPrdDetails.ItemTypeId,
                                ProductTypeName: LaborPrdDetails.ProductTypeName,
                                ProductTypeId: LaborPrdDetails.ProductTypeId,
                                Attribute: LaborPrdDetails.Attribute,
                                AttributeId: x.AttributeId,
                                ProcessId: LProcessID,
                                Pieces: options.Pieces,
                                Weight: options.Weight,
                                Parts: options.Parts,
                                CalcOnId: x.CalcOnId,
                                ProcessName: LProcess.ProcessName,
                                //LabourRate: LRate,
                                //LabourAmount: LAmount,
                                CategoryId: ATBDetails.CategoryId,
                                SubCategoryId: ATBDetails.SubCategoryId,
                                QualityId: ATBDetails.QualityId,
                                ShapeId: ATBDetails.ShapeId,
                                StoneSizeId: ATBDetails.StoneSizeId,
                                SieveId: ATBDetails.SieveId,
                                StoneColorId: ATBDetails.StoneColorId,
                                WstPer: LRate,
                                WstWt: LAmount
                            }

                        }
                    }
                    if (PurchaseLabor != null)
                        labordetail.push(PurchaseLabor);
                });
        }
        catch (undefined) {
            Q.notifyWarning("Labor Rate not defined");
        }
        let labordetails = [];
        if (labordetail.length > 0)
            $.each(labordetail, function (i, el) {
                if ($.inArray(el, labordetails) === -1) labordetails.push(el);
            });

        return labordetails;
    }

    export function GetSalesLabour(options: LaborCalOptions) {

        let LaborRate = 0;
        let labordetail = [];
        let ItemLabor: any[];
        let ATBDetails: OMS.CommonAttributesRow;
        let PurchaseLabor: Sales.SalesLaborRow;

        OMS.CommonAttributesService.Retrieve({ EntityId: options.AttributeId }, response => ATBDetails = response.Entity, { async: false });

        let Key: number;
        switch (ATBDetails.ItemTypeId) {
            case 101:
                Key = 1002;
                break;
            case 105:
                if (options.SettingId == 0)
                    Key = 1028;
                else
                    Key = 1047;
                break;

        }

        let LabourConfig =  (GetConfigValue(Key)); 

        let LabourATBType = parseInt(LabourConfig) || 1; // set this using global config
        try {

            OMS.LabourMasterService.GetLaborRate(
                {
                    LaborMode: LabourATBType,
                    AttributeId: options.AttributeId,
                    PriceListId: options.RateListId,
                    IsCustomerItem: options.IsCustomerItem,
                    SettingId: options.SettingId,
                    Weight: options.Weight,
                    Pieces: options.Pieces,
                    Parts: options.Parts

                },
                response => ItemLabor = response.Entities,
                {
                    async: false
                }
            );
            if (ItemLabor != null)
                ItemLabor.forEach(function (x) {
                    let Pieces= options.Pieces;
                    let Weight = options.Weight;
                    let Parts = options.Parts;
                    if (options.ProductId != null && options.ProductId > 0) {
                        let LaborPrdDetails: OMS.ProductMasterRow;
                        OMS.ProductMasterService.Retrieve({ EntityId: options.ProductId },
                            response => LaborPrdDetails = response.Entity, { async: false });
                        let LRateType = x.RateType;
                        let LRate = 0;
                        if (LRateType == 1) {
                            let MetalRate = OMS.MetalRateMasterRow.getLookup().items.filter(z => z.MetalTypeId == LaborPrdDetails.MetalId &&
                                z.RateTypeId == 33 && z.CompanyId == Q.Authorization.userDefinition.CompanyId)[0].Rate
                            if (options.RateListId > 0)
                                LRate = options.Markup > 0 ? MetalRate * ((x.Amount / 100) + (options.Markup / 100)) : MetalRate * (x.Amount / 100);
                            else
                                LRate = MetalRate * (x.SaleStdLabour / 100);
                        }
                        else {

                            if (options.RateListId > 0)
                                LRate = options.Markup > 0 ? x.Amount * options.Markup : x.Amount;
                            else
                                LRate = options.Markup > 0 ? x.SaleStdLabour * options.Markup : x.SaleStdLabour;
                        }
                        let LProcessID = x.ProcessId;
                        let LProcess = OMS.ProcessMasterRow.getLookup().itemById[LProcessID]
                        //let CalcOn = OMS.FixedCodeRow.getLookup().itemById[LProcess.CalcOnId].FixedCode;

                        let LAmount;

                        switch (x.CalcOnId) {
                            case 61:
                                LAmount = options.Pieces * LRate;
                                break;
                            case 62:
                                LAmount = options.NetWeight * LRate;
                                break;
                            case 63:
                                LAmount = options.Weight * LRate;
                                break;
                            case 65:
                                LAmount = ATBDetails.ItemTypeId == 101 ? options.DiamondWeight * LRate : options.Weight * LRate;
                                Pieces = ATBDetails.ItemTypeId == 101 ? options.DiamondPieces : options.Pieces;
                                break;
                            case 64:
                                LAmount = ATBDetails.ItemTypeId == 101 ? options.StoneWeight * LRate : options.Weight * LRate;
                                Pieces = ATBDetails.ItemTypeId == 101 ? options.StonePieces : options.Pieces;
                                break;
                            case 66:
                                LAmount = options.Parts * LRate;
                                break;

                        }

                        if (LAmount < x.MinLabour) {
                            LAmount = x.MinLabour;
                            switch (x.CalcOnId) {
                                case 61:
                                    LRate = LAmount / options.Pieces;
                                    break;
                                case 62:
                                    LRate = LAmount / options.NetWeight;
                                    break;
                                case 63:
                                    LRate = LAmount / options.Weight;
                                    break;
                                case 65:
                                    LRate = ATBDetails.ItemTypeId == 101 ? LAmount / options.DiamondWeight : LAmount / options.Weight;
                                    break;
                                case 64:
                                    LRate = ATBDetails.ItemTypeId == 101 ? LAmount / options.StoneWeight : LAmount / options.Weight;
                                    break;
                                case 66:
                                    LRate = LAmount/ options.Parts;
                                    break;

                            }
                        }

                        LaborRate += LAmount;
                        PurchaseLabor =
                        {
                            ItemTypeId: LaborPrdDetails.ItemTypeId,
                            ProductTypeName: LaborPrdDetails.ProductTypeName,
                            ProductTypeId: LaborPrdDetails.ProductTypeId,
                            Attribute: LaborPrdDetails.Attribute,
                            AttributeId: x.AttributeId,
                            ProcessId: LProcessID,
                            Pieces: Pieces,
                            Parts:options.Parts,
                            Weight: Weight,
                            CalcOnId: x.CalcOnId,
                            ProcessName: LProcess.ProcessName,
                            LabourRate: LRate,
                            LabourAmount: LAmount,
                            CategoryId: ATBDetails.CategoryId,
                            SubCategoryId: ATBDetails.SubCategoryId,
                            QualityId: ATBDetails.QualityId,
                            ShapeId: ATBDetails.ShapeId,
                            StoneSizeId: ATBDetails.StoneSizeId,
                            SieveId: ATBDetails.SieveId,
                            StoneColorId: ATBDetails.StoneColorId,
                            IsCustomerItem: options.IsCustomerItem

                        }

                        labordetail.push(PurchaseLabor);
                    }
                    else {
                        let LRateType = x.RateType;
                        let LRate = 0;
                        if (LRateType == 1) {
                            let MetalRate = OMS.MetalRateMasterRow.getLookup().items.filter(z => z.MetalTypeId == ATBDetails.MetalId &&
                                z.RateTypeId == 33 && z.CompanyId == Q.Authorization.userDefinition.CompanyId)[0].Rate
                            if (options.RateListId > 0)
                                LRate = options.Markup > 0 ? MetalRate * ((x.Amount / 100) + (options.Markup / 100)) : MetalRate * (x.Amount / 100);
                            else
                                LRate = MetalRate * (x.SaleStdLabour / 100);
                        }
                        else {

                            if (options.RateListId > 0)
                                LRate = options.Markup > 0 ? x.Amount * options.Markup : x.Amount;
                            else
                                LRate = options.Markup > 0 ? x.SaleStdLabour * options.Markup : x.SaleStdLabour;
                        }
                        let LProcessID = x.ProcessId;
                        let LProcess = OMS.ProcessMasterRow.getLookup().itemById[LProcessID]
                        //let CalcOn = OMS.FixedCodeRow.getLookup().itemById[LProcess.CalcOnId].FixedCode;

                        let LAmount;

                        switch (x.CalcOnId) {
                            case 61:
                                LAmount = options.Pieces * LRate;
                                break;
                            case 62:
                                LAmount = options.NetWeight * LRate;
                                break;
                            case 63:
                                LAmount = options.Weight * LRate;
                                break;
                            case 65:
                                LAmount = ATBDetails.ItemTypeId == 101 ? options.DiamondWeight * LRate : options.Weight * LRate;
                                Pieces = ATBDetails.ItemTypeId == 101 ? options.DiamondPieces : options.Pieces;
                                Weight = ATBDetails.ItemTypeId == 101 ? options.DiamondWeight : options.Weight;
                                break;
                            case 64:
                                LAmount = ATBDetails.ItemTypeId == 101 ? options.StoneWeight * LRate : options.Weight * LRate;
                                Pieces = ATBDetails.ItemTypeId == 101 ? options.StonePieces : options.Pieces;
                                Weight = ATBDetails.ItemTypeId == 101 ? options.StoneWeight : options.Weight;
                                break;
                            case 66:
                                LAmount = options.Parts * LRate;
                                break;

                        }

                        if (LAmount < x.MinLabour) {
                            LAmount = x.MinLabour;
                            switch (x.CalcOnId) {
                                case 61:
                                    LRate = LAmount / options.Pieces;
                                    break;
                                case 62:
                                    LRate = LAmount / options.NetWeight;
                                    break;
                                case 63:
                                    LRate = LAmount / options.Weight;
                                    break;
                                case 65:
                                    LRate = ATBDetails.ItemTypeId == 101 ? LAmount / options.DiamondWeight : LAmount / options.Weight;
                                    break;
                                case 64:
                                    LRate = ATBDetails.ItemTypeId == 101 ? LAmount / options.StoneWeight : LAmount / options.Weight;
                                    break;

                            }
                        }

                        LaborRate += LAmount;
                        PurchaseLabor =
                        {
                            ItemTypeId: ATBDetails.ItemTypeId,
                            ProductTypeName: ATBDetails.ProductTypeName,
                            ProductTypeId: ATBDetails.ProductTypeId,
                            Attribute: ATBDetails.Attribute,
                            AttributeId: x.AttributeId,
                            ProcessId: LProcessID,
                            Pieces: Pieces,
                            Weight: Weight,
                            Parts:options.Parts,
                            CalcOnId: x.CalcOnId,
                            ProcessName: LProcess.ProcessName,
                            LabourRate: LRate,
                            LabourAmount: LAmount,
                            CategoryId: ATBDetails.CategoryId,
                            SubCategoryId: ATBDetails.SubCategoryId,
                            QualityId: ATBDetails.QualityId,
                            ShapeId: ATBDetails.ShapeId,
                            StoneSizeId: ATBDetails.StoneSizeId,
                            SieveId: ATBDetails.SieveId,
                            StoneColorId: ATBDetails.StoneColorId,
                            IsCustomerItem: options.IsCustomerItem

                        }

                        labordetail.push(PurchaseLabor);
                    }
                });

        }
        catch (undefined) {
            console.warn("Labor Rate not defined");
        }
        let labordetails = [];
        if (labordetail.length > 0)
            $.each(labordetail, function (i, el) {
                if ($.inArray(el, labordetails) === -1) labordetails.push(el);
            });

        return labordetails;
    }

    export function ApplyPurchseLabour(Product: any, Processes: OMS.ProcessMasterRow[], RateListId: number, Markup: number, TransDate: Date) {

        let LaborRate = 0;
        let LRate = 0;
        let labordetail = [];
        let ItemLabor: any;
        let Item = Q.deepClone(Product); 
        let LabourConfig =  (GetConfigValue(1002)); 
        let PurchaseLabor: Purchase.PurchaseLaborRow

        let LabourATBType = parseInt(LabourConfig) || 1; // set this using global config
        Processes.forEach(function (Process) {

            try {

                if (Process.ItemTypeId == 101) {
                    OMS.LabourMasterService.GetLaborRate(
                        {
                            LaborMode: LabourATBType, AttributeId: Item.AttributeId, PriceListId: RateListId, IsCustomerItem: Item.IsCustomerItem, Weight: Item.Weight, ProcessId: Process.ProcessId
                        },
                        response => ItemLabor = response.Entities,
                        {
                            async: false
                        }
                    );
                }
                if (Process.ItemTypeId == 105) {
                    let StoneLabConfig = (GetConfigValue(1028));  
                    let StoneLabourType = parseInt(StoneLabConfig) || 1;
                    if (Item.ItemTypeId == 101) {

                        let Stones = Item.BOMDetails.filter(x => x.ItemTypeId == 105);

                        Stones.forEach(function (stone: Purchase.PurchaseItemsBOMRow) {
                            if (Process.IsSetting)
                                OMS.LabourMasterService.GetLaborRate(
                                    {
                                        LaborMode: StoneLabourType,
                                        AttributeId: stone.BOMAttributeId,
                                        PriceListId: RateListId,
                                        IsCustomerItem: stone.IsCustomerItem,
                                        Weight: stone.Weight,
                                        SettingId: stone.SettingId,
                                        ProcessId: Process.ProcessId,
                                        Pieces: stone.Pieces
                                    },
                                    response => ItemLabor = response.Entities,
                                    {
                                        async: false
                                    }
                                );
                            else
                                OMS.LabourMasterService.GetLaborRate(
                                    {
                                        LaborMode: StoneLabourType,
                                        AttributeId: stone.BOMAttributeId,
                                        PriceListId: RateListId,
                                        IsCustomerItem: stone.IsCustomerItem,
                                        Weight: stone.Weight,
                                        ProcessId: Process.ProcessId,
                                        Pieces: stone.Pieces
                                    },
                                    response => ItemLabor = response.Entities,
                                    {
                                        async: false
                                    }
                                );
                        });
                    }
                    else {
                        OMS.LabourMasterService.GetLaborRate(
                            {
                                LaborMode: StoneLabourType,
                                AttributeId: Item.AttributeId,
                                PriceListId: RateListId,
                                IsCustomerItem: Item.IsCutomerItem,
                                Weight: Item.Weight,
                                ProcessId: Process.ProcessId,
                                Pieces: Item.Pieces
                            },
                            response => ItemLabor = response.Entities,
                            {
                                async: false
                            }
                        );

                    }
                }

                if (ItemLabor != null)
                    ItemLabor.forEach(function (x: Common.LaborRateResponse) {
                        if (Process.ProcessCode.toUpperCase() == "WASTAGE") {
                            let LRateType = x.RateType;
                            let LRate = 0;
                            let CalcOn = OMS.FixedCodeRow.getLookup().itemById[Process.CalcOnId].FixedCode;
                            if (RateListId > 0)
                                LRate = Markup > 0 ? x.Amount * Markup : x.Amount;
                            else
                                LRate = Markup > 0 ? x.PurStdLabour * Markup : x.PurStdLabour;
                            let LAmount = x.CalcOnId == 61 ? Item.Pieces * LRate : (Item.Weight * LRate) / 100;

                            LaborRate += LAmount;

                            PurchaseLabor =
                            {
                                ItemTypeId: x.ItemTypeId,
                                ProductTypeName: x.ProductTypeName,
                                ProductTypeId: x.ProductTypeId,
                                Attribute: Item.Attribute,
                                AttributeId: x.AttributeId,
                                ProcessId: Process.ProcessId,
                                Parts: Item.Parts,
                                Pieces: Item.Pieces,
                                Weight: Item.Weight,
                                CalcOnId: x.CalcOnId,
                                ProcessName: Process.ProcessName,
                                WstPer: LRate,
                                WstWt: LAmount
                            }

                        }
                        else {
                            let LRateType = x.RateType;
                            LRate = 0;

                            if (LRateType == 1) {
                                let MetalRate = OMS.MetalRateMasterRow.getLookup().items.filter(z => z.MetalTypeId == x.MetalId
                                    && z.RateTypeId == 33 && z.CompanyId == Q.Authorization.userDefinition.CompanyId)[0].Rate;
                                if (RateListId > 0)
                                    LRate = Markup > 0 ? MetalRate * (x.Amount / 100) * Markup : MetalRate * (x.Amount / 100);
                                else
                                    LRate = MetalRate * (x.PurStdLabour / 100);
                            }
                            else {

                                if (RateListId > 0)
                                    LRate = Markup > 0 ? x.Amount * Markup : x.Amount;
                                else
                                    LRate = Markup > 0 ? x.PurStdLabour * Markup : x.PurStdLabour;
                            }

                            let LAmount;

                            switch (x.CalcOnId) {
                                case 61:
                                    LAmount = x.Pieces * LRate;
                                    break;
                                case 62:
                                    LAmount = Item.NetWeight * LRate;
                                    break;
                                case 63:
                                    LAmount = x.Weight * LRate;
                                    break;
                                case 66:
                                    LAmount = Item.Parts * LRate;
                                    break;

                            }

                            LaborRate += LAmount;
                            if (LAmount < x.MinLabour) {
                                LAmount = x.MinLabour;

                            }
                            PurchaseLabor =
                            {
                                ItemTypeId: x.ItemTypeId,
                                ProductTypeName: x.ProductTypeName,
                                ProductTypeId: x.ProductTypeId,
                                Attribute: Item.Attribute,
                                AttributeId: x.AttributeId,
                                ProcessId: Process.ProcessId,
                                Parts: Item.Parts,
                                Pieces: x.Pieces,
                                Weight: x.Weight,
                                CalcOnId: x.CalcOnId,
                                ProcessName: Process.ProcessName,
                                LabourRate: LRate,
                                LabourAmount: LAmount,
                                CalculateTo: x.CalculateTo
                            }
                        }

                        if (PurchaseLabor != null)
                            labordetail.push(PurchaseLabor);
                    });

                if (labordetail.length == 0) {

                    if (Item.ProductTypeName == null)
                        Item.ProductTypeName = OMS.ProductTypeRow.getLookup().itemById[Item.ProductTypeId].ProductTypeName;

                    let Labor: Purchase.PurchaseLaborRow =
                    {
                        ItemTypeId: Item.ItemTypeId,
                        ProductTypeName: Item.ProductTypeName,
                        ProductTypeId: Item.ProductTypeId,
                        Attribute: Item.Attribute,
                        AttributeId: Item.AttributeId,
                        ProcessId: Process.ProcessId,
                        Pieces: Item.Pieces,
                        Parts: Item.Parts,
                        Weight: Item.Weight,
                        CalcOnId: Process.CalcOnId,
                        ProcessName: Process.ProcessName,
                        LabourRate: 0,
                        LabourAmount: 0,
                        CalculateTo: Process.CalculateTo
                    }

                    if (Labor != null)
                        labordetail.push(Labor);
                }

            }
            catch (undefined) {
                Q.notifyWarning("Labor Rate not defined");
            }
        });
        let labordetails = [];
        if (labordetail.length > 0)
            $.each(labordetail, function (i, el) {
                if ($.inArray(el, labordetails) === -1) labordetails.push(el);
            });

        return labordetails;
    }

    export function ApplySalesLabour(Product: any, Processes: OMS.ProcessMasterRow[], RateListId: number, Markup: number, TransDate: Date) {

        let LaborRate = 0;
        let LRate = 0;
        let labordetail = [];
        let ItemLabor = [];
        let Item = Q.deepClone(Product); 
        let LabourConfig = (GetConfigValue(1002)); 
        let PurchaseLabor: Purchase.PurchaseLaborRow;

        let LabourATBType = parseInt(LabourConfig) || 1; // set this using global config
        Processes.forEach(function (Process) {

            try {

                if (Process.ItemTypeId == 101) {
                    let LResponse: Serenity.ListResponse<Common.LaborRateResponse>;
                    OMS.LabourMasterService.GetLaborRate(
                        {
                            LaborMode: LabourATBType, AttributeId: Item.AttributeId, PriceListId: RateListId, IsCustomerItem: Item.IsCustomerItem, Weight: Item.Weight, ProcessId: Process.ProcessId
                        },
                        response => LResponse = response,
                        {
                            async: false
                        }
                    );
                    if (LResponse.TotalCount > 0) {
                        LResponse.Entities.forEach(function (x) {
                            ItemLabor.push(x);
                        });
                    }
                }
                if (Process.ItemTypeId == 105) {
                    let StoneLabConfig = (GetConfigValue(1028));  
                    let StoneLabourType = parseInt(StoneLabConfig) || 1;
                    if (Item.ItemTypeId == 101) {

                        if (Item.BOMDetails !== undefined) {
                            let Stones = Item.BOMDetails.filter(x => x.ItemTypeId == 105);

                            Stones.forEach(function (stone: Sales.SalesItemsBOMRow) {
                                if (Process.IsSetting)
                                    OMS.LabourMasterService.GetLaborRate(
                                        {
                                            LaborMode: StoneLabourType,
                                            AttributeId: stone.BOMAttributeId,
                                            PriceListId: RateListId,
                                            IsCustomerItem: stone.IsCustomerItem,
                                            Weight: stone.Weight,
                                            SettingId: stone.SettingId,
                                            ProcessId: Process.ProcessId,
                                            Pieces: stone.Pieces
                                        },
                                        response => response.Entities.forEach(function (entity) {
                                            ItemLabor.push(entity);
                                        }),
                                        {
                                            async: false
                                        }
                                    );
                                else
                                    OMS.LabourMasterService.GetLaborRate(
                                        {
                                            LaborMode: StoneLabourType,
                                            AttributeId: stone.BOMAttributeId,
                                            PriceListId: RateListId,
                                            IsCustomerItem: stone.IsCustomerItem,
                                            Weight: stone.Weight,
                                            ProcessId: Process.ProcessId,
                                            Pieces: stone.Pieces
                                        },
                                        response => response.Entities.forEach(function (entity) {
                                            ItemLabor.push(entity);
                                        }),
                                        {
                                            async: false
                                        }
                                    );
                            });
                        }
                    }
                    else {
                        OMS.LabourMasterService.GetLaborRate(
                            {
                                LaborMode: StoneLabourType,
                                AttributeId: Item.AttributeId,
                                PriceListId: RateListId,
                                IsCustomerItem: Item.IsCutomerItem,
                                Weight: Item.Weight,
                                ProcessId: Process.ProcessId,
                                Pieces: Item.Pieces
                            },
                            response => response.Entities.forEach(function (entity) {
                                ItemLabor.push(entity);
                            }),
                            {
                                async: false
                            }
                        );

                    }
                }

                if (ItemLabor.length > 0)
                    ItemLabor.forEach(function (x: Common.LaborRateResponse) {
                        if (Process.ProcessCode.toUpperCase() == "WASTAGE") {
                            let LRateType = x.RateType;
                            let LRate = 0;
                            let CalcOn = OMS.FixedCodeRow.getLookup().itemById[Process.CalcOnId].FixedCode;
                            if (RateListId > 0)
                                LRate = Markup > 0 ? x.Amount * Markup : x.Amount;
                            else
                                LRate = Markup > 0 ? x.SaleStdLabour * Markup : x.SaleStdLabour;
                            //let LAmount = x.CalcOnId == 61 ? Item.Pieces * LRate : (Item.Weight * LRate) / 100;

                            let LAmount;

                            switch (x.CalcOnId) {
                                case 61:
                                    LAmount = Item.Pieces * LRate;
                                    break;
                                case 62:
                                    LAmount = (Item.NetWeight * LRate) / 100
                                    break;
                                case 63:
                                    LAmount = (Item.Weight * LRate) / 100;
                                    break;
                                case 66:
                                    (Item.Parts * LRate) / 100;
                                    break;

                            }

                            LaborRate += LAmount;

                            PurchaseLabor = {
                                ItemTypeId: x.ItemTypeId,
                                ProductTypeName: x.ProductTypeName,
                                ProductTypeId: x.ProductTypeId,
                                Attribute: Item.Attribute,
                                AttributeId: x.AttributeId,
                                ProcessId: Process.ProcessId,
                                Pieces: Item.Pieces,
                                Weight: Item.Weight,
                                CalcOnId: x.CalcOnId,
                                ProcessName: Process.ProcessName,
                                WstPer: LRate,
                                WstWt: LAmount,
                                CalculateTo: x.CalculateTo
                            }

                        }
                        else {
                            let LRateType = x.RateType;
                            LRate = 0;

                            if (LRateType == 1) {
                                let MetalRate = OMS.MetalRateMasterRow.getLookup().items.filter(z => z.MetalTypeId == x.MetalId
                                    && z.RateTypeId == 33 && z.CompanyId == Q.Authorization.userDefinition.CompanyId)[0].Rate;
                                if (RateListId > 0)
                                    LRate = Markup > 0 ? MetalRate * (x.Amount / 100) * Markup : MetalRate * (x.Amount / 100);
                                else
                                    LRate = MetalRate * (x.PurStdLabour / 100);
                            }
                            else {

                                if (RateListId > 0)
                                    LRate = Markup > 0 ? x.Amount * Markup : x.Amount;
                                else
                                    LRate = Markup > 0 ? x.SaleStdLabour * Markup : x.SaleStdLabour;
                            }

                            let LAmount;

                            switch (x.CalcOnId) {
                                case 61:
                                    LAmount = x.Pieces * LRate;
                                    break;
                                case 62:
                                    LAmount = Item.NetWeight * LRate;
                                    break;
                                case 63:
                                    LAmount = x.Weight * LRate;
                                    break;
                                case 66:
                                    LAmount = Item.Parts * LRate;
                                    break;

                            }

                            LaborRate += LAmount;
                            if (LAmount < x.MinLabour) {
                                LAmount = x.MinLabour;
                            }
                            PurchaseLabor =
                            {
                                ItemTypeId: x.ItemTypeId,
                                ProductTypeName: x.ProductTypeName,
                                ProductTypeId: x.ProductTypeId,
                                Attribute: Item.Attribute,
                                AttributeId: x.AttributeId,
                                ProcessId: Process.ProcessId,
                                Parts: Item.Parts,
                                Pieces: x.Pieces,
                                Weight: x.Weight,
                                CalcOnId: x.CalcOnId,
                                ProcessName: Process.ProcessName,
                                LabourRate: LRate,
                                LabourAmount: LAmount,
                                CalculateTo: x.CalculateTo
                            }
                        }

                        if (PurchaseLabor != null)
                            labordetail.push(PurchaseLabor);
                    });

                if (labordetail.length == 0) {

                    if (Item.ProductTypeName == null)
                        Item.ProductTypeName = OMS.ProductTypeRow.getLookup().itemById[Item.ProductTypeId].ProductTypeName;

                    let Labor: Purchase.PurchaseLaborRow =
                    {
                        ItemTypeId: Item.ItemTypeId,
                        ProductTypeName: Item.ProductTypeName,
                        ProductTypeId: Item.ProductTypeId,
                        Attribute: Item.Attribute,
                        AttributeId: Item.AttributeId,
                        ProcessId: Process.ProcessId,
                        Parts: Item.Parts,
                        Pieces: Item.Pieces,
                        Weight: Item.Weight,
                        CalcOnId: Process.CalcOnId,
                        ProcessName: Process.ProcessName,
                        LabourRate: 0,
                        LabourAmount: 0,
                        CalculateTo: Process.CalculateTo
                    }

                    if (Labor != null)
                        labordetail.push(Labor);
                }

            }
            catch (undefined) {
                Q.notifyWarning("Labor Rate not defined");
            }
        });
        let labordetails = [];
        if (labordetail.length > 0)
            $.each(labordetail, function (i, el) {
                if ($.inArray(el, labordetails) === -1) labordetails.push(el);
            });

        return labordetails;
    }


    // #region Stone Rate 

    export function GetStonePurchaseRate(AttributeId: number, RateListId: number, ProductId: number, CostMethodId: number, Weight?: number) {

        let Rate = 0;
        let LRate = [];
        let ATBDetails: OMS.CommonAttributesRow;

        OMS.CommonAttributesService.Retrieve({ EntityId: AttributeId }, response => ATBDetails = response.Entity, { async: false });
        let rateatb: RateAttributes = {
            ProductTypeId: ATBDetails.ProductTypeId,
            CategoryId: ATBDetails.CategoryId,
            SubCategoryId: ATBDetails.SubCategoryId,
            ShapeId: ATBDetails.ShapeId,
            SieveId: ATBDetails.SieveId,
            GroupSieveId: ATBDetails.GroupSieveId,
            StoneSizeId: ATBDetails.StoneSizeId,
            StoneColorId: ATBDetails.StoneColorId,
            QualityId: ATBDetails.QualityId,
            RateListId: RateListId,
            ProductId: ProductId,
            CostMethodId: CostMethodId,
            Weight: Weight
        }
        Rate = GetStonePurchaseRatenoAtb(rateatb);

        return Rate;
    }

    export function GetStoneSalesRate(AttributeId: number, RateListId: number, ProductId: number, CostMethodId: number, Weight?: number) {

        let Rate = 0;
        let ATBDetails: OMS.CommonAttributesRow;

        OMS.CommonAttributesService.Retrieve({ EntityId: AttributeId }, response => ATBDetails = response.Entity, { async: false });
        let rateatb: RateAttributes = {
            ProductTypeId: ATBDetails.ProductTypeId,
            CategoryId: ATBDetails.CategoryId,
            SubCategoryId: ATBDetails.SubCategoryId,
            ShapeId: ATBDetails.ShapeId,
            SieveId: ATBDetails.SieveId,
            GroupSieveId: ATBDetails.GroupSieveId,
            StoneSizeId: ATBDetails.StoneSizeId,
            StoneColorId: ATBDetails.StoneColorId,
            QualityId: ATBDetails.QualityId,
            RateListId: RateListId,
            ProductId: ProductId,
            CostMethodId: CostMethodId,
            Weight: Weight
        }
        Rate = GetStoneSalesRatenoAtb(rateatb);

        return Rate;
    }

    export function GetStonePurchaseRatenoAtb(attributes: RateAttributes) {

        let Rate = 0;

        OMS.RateMasterService.GetItemRate({
            ProductTypeId: attributes.ProductTypeId,
            CategoryId: attributes.CategoryId,
            SubCategoryId: attributes.SubCategoryId,
            ShapeId: attributes.ShapeId,
            StoneColorId: attributes.StoneColorId,
            QualityId: attributes.QualityId,
            SieveId: attributes.SieveId,
            StoneSizeId: attributes.StoneSizeId,
            RateListId: attributes.RateListId,
            Weight: attributes.Weight,
            CostMethodId: attributes.CostMethodId,
            IsPurchase: true
        }, response => {
            let ent = response.Entities;
            Rate = ent[0].PurStdRate;
        }, { async: false })
        return Rate;


    }

    export function GetStoneSalesRatenoAtb(attributes: RateAttributes) {


        let Rate = 0;

        OMS.RateMasterService.GetItemRate({
            ProductTypeId: attributes.ProductTypeId,
            CategoryId: attributes.CategoryId,
            SubCategoryId: attributes.SubCategoryId,
            ShapeId: attributes.ShapeId,
            StoneColorId: attributes.StoneColorId,
            QualityId: attributes.QualityId,
            SieveId: attributes.SieveId,
            StoneSizeId: attributes.StoneSizeId,
            RateListId: attributes.RateListId,
            Weight: attributes.Weight,
            CostMethodId: attributes.CostMethodId,
            IsPurchase: false,
            ProductId: attributes.ProductId
        }, response => {
            let ent = response.Entities;
            Rate = ent[0].PurStdRate;
        }, { async: false })
        return Rate;

    }

    // #endregion 

    export function GetMetalRate(MetalId: number, KaratId: number, IsSales: boolean, TransDate: Date) {

        let Rate = 0;
        let userDetails = Q.Authorization.userDefinition 
        Q.reloadLookup(OMS.MetalRateMasterRow.lookupKey);
        Q.reloadLookup(OMS.KaratRateRow.lookupKey);
        let UseKaratRate = q.ToBool(GetConfigValue(1014)); 
        let rates: OMS.KaratRateRow[];


        try {
            if (IsSales) {
                if (UseKaratRate == true) {
                    OMS.KaratRateService.GetRate(
                        {
                            ItemTypeId: 104,
                            ProductTypeId: MetalId,
                            KaratId: KaratId,
                            FromDate: TransDate.toDateString(),
                            ToDate: TransDate.toDateString()
                        },
                        response => rates = response.Entities,
                        {
                            async: false
                        });
                    if (rates == undefined || rates.length == 0) {
                        let Karat = OMS.AttributeMasterRow.getLookup().itemById[KaratId];
                        let MRate = OMS.MetalRateMasterRow.getLookup().items.filter(x =>
                            x.MetalTypeId == MetalId
                            && x.RateTypeId == 34
                            && x.CompanyId == userDetails.CompanyId
                            && new Date(x.FromDate) <= new Date(TransDate.toString())).sort().pop().Rate || 0;

                        Rate = MRate * Karat.SalesFormula;

                    }
                    else {
                        rates.sort(function (x, y) {
                            let a = new Date(x.FromDate),
                                b = new Date(y.FromDate);
                            return +b.valueOf - +a.valueOf;
                        });
                        if (rates.length > 0) {
                            //Rate = R.pop().RateOn == "Gram" ? R.pop().Rate * (1 + (R.pop().LossPercent / 100)) : (R.pop().Rate / 31.1) * (1 + (R.pop().LossPercent / 100));
                            Rate = rates.pop().SaleStdRate;
                        }
                    }
                }
                else {
                    let R = OMS.MetalRateMasterRow.getLookup().items.filter(x =>
                        x.MetalTypeId == MetalId
                        && x.RateTypeId == 34
                        && x.CompanyId == userDetails.CompanyId
                        && new Date(x.FromDate) <= new Date(TransDate.toString())
                        //&& new Date(x.ToDate) >= new Date(TransDate.toString())
                    );

                    R.sort(function (x, y) {
                        let a = new Date(x.FromDate),
                            b = new Date(y.FromDate);
                        return +b.valueOf - +a.valueOf;
                    });
                    if (R.length > 0) {
                        //Rate = R.pop().RateOn == "Gram" ? R.pop().Rate * (1 + (R.pop().LossPercent / 100)) : (R.pop().Rate / 31.1) * (1 + (R.pop().LossPercent / 100));
                        let Rates = R.pop();
                        if (Rates.RateOn == "Gram")
                            Rate = Rates.Rate * (1 + (Rates.LossPercent / 100));
                        else {
                            let toGram = (Rates.Rate / 31.1)
                            Rate = Rates.LossPercent === undefined ? toGram : toGram * (1 + Rates.LossPercent / 100);
                        }
                    }

                }
                   
            }
            else {
                let R = OMS.MetalRateMasterRow.getLookup().items.filter(x =>
                    x.MetalTypeId == MetalId
                    && x.RateTypeId == 33
                    && x.CompanyId == userDetails.CompanyId
                    && new Date(x.FromDate) <= new Date(TransDate.toString())
                    //&& new Date(x.ToDate) >= new Date(TransDate.toString())
                );

                R.sort(function (x, y) {
                    let a = new Date(x.FromDate),
                        b = new Date(y.FromDate);
                    return +b.valueOf - +a.valueOf;
                });
                if (R.length > 0) {
                    //Rate = R.pop().RateOn == "Gram" ? R.pop().Rate * (1 + (R.pop().LossPercent / 100)) : (R.pop().Rate / 31.1) * (1 + (R.pop().LossPercent / 100));
                    let Rates = R.pop();
                    if (Rates.RateOn == "Gram")
                        Rate = Rates.Rate * (1 + (Rates.LossPercent / 100));
                    else {
                        let toGram = (Rates.Rate / 31.1)
                        Rate = Rates.LossPercent === undefined ? toGram : toGram * (1 + Rates.LossPercent / 100);
                    }
                }
                else
                    Rate = 0;
            }
        }
        catch (undefined) {
            q.alert("", "Rate Not Defined!", true)
            return Rate = 0;
        }

        return Rate;
    }

    export function ReCalculateMarkUp(MF: number, MFAmount: number, BOMDetails: Retail.POSSalesItemsBOMRow[], LaborDetails: Retail.POSSalesLaborRow[], Pieces: number, Weight: number, NetWeight: number, FancyCharges: number, OtherCharges: number) {
        let mf = MF;
        let mfamount = MFAmount * mf;

        let bomdetails = BOMDetails;
        let labordetails = LaborDetails;
        let rate = 0;
        let totalstoneamount = 0;
        let totalmetalamount = 0;
        let totallaboramount = 0;
        let labormfamount = 0; let stonemfamount = 0; 
        let includelabor = q.ToBool(GetConfigValue(1041)); 
        if (includelabor == true) {
            for (let i = 0; i < labordetails.length; i++) {
                let labor = labordetails[i];
                totallaboramount += labor.LabourAmount;
            }
        }
        for (let i = 0; i < bomdetails.length; i++) {
            let _bom = bomdetails[i];
            if (_bom.ItemTypeId == 105) {
                //let stoneamount = _bom.BomAmount > 0 ? _bom.BomAmount : _bom.CCBomAmount;
                let stoneamount = _bom.BomAmount;
                if (stoneamount > 0)
                    totalstoneamount += stoneamount;
            }
            else if (_bom.ItemTypeId == 104)
                totalmetalamount += _bom.BomAmount;
        }
        mfamount -= totalmetalamount;
        if (totallaboramount > 0) {
            stonemfamount = (totalstoneamount / (totallaboramount + totalstoneamount)) * mfamount;
            labormfamount = (totallaboramount / (totallaboramount + totalstoneamount)) * mfamount;
        } else {
            stonemfamount = mfamount;
        }

        let newstoneamount= 0;
        for (let i = 0; i < bomdetails.length; i++) {
            let bom = bomdetails[i];
            if (bom.ItemTypeId == 105) {
                bom.BomAmount = (bom.BomAmount / totalstoneamount) * stonemfamount;
                //bom.CCBomAmount = bom.BomAmount;
                if (bom.CalcOnId == 3)
                    bom.BomRate = bom.BomAmount / bom.Pieces;
                else
                    bom.BomRate = bom.BomAmount / bom.Weight;

                let _rate = bom.BomRate;
                let rem = _rate % 100;
                let temp = rem > 50 ? Math.ceil(_rate / 100) : Math.floor(_rate / 100);
                _rate = temp * 100;
                bom.BomRate = _rate;
                if (bom.CalcOnId == 3)
                    bom.BomAmount = bom.BomRate * bom.Pieces;
                else
                    bom.BomAmount = bom.BomRate * bom.Weight;

            }
            rate += bom.BomAmount;
            newstoneamount += bom.BomAmount;
            bomdetails[i] = bom;
        }
        let newlaboramount = 0;
        if (totallaboramount > 0) {
            for (let i = 0; i < labordetails.length; i++) {
                let _labor = labordetails[i];
                _labor.LabourAmount = (_labor.LabourAmount / totallaboramount) * labormfamount;
                //_labor.CCLabourAmount = _labor.LabourAmount;
                switch (_labor.CalcOnId) {
                    case 61:
                        _labor.LabourRate = _labor.LabourAmount / Pieces;
                        break;
                    case 62:
                        _labor.LabourRate = _labor.LabourAmount / NetWeight;
                        break;
                    case 63:
                        _labor.LabourRate = _labor.LabourAmount / Weight;
                        break;
                }
                let _lrate = _labor.LabourRate;
                let rem = _lrate % 100;
                let temp = rem > 50 ? Math.ceil(_lrate / 100) : Math.floor(_lrate / 100);
                _lrate = temp * 100;
                _labor.LabourRate = _lrate;
                switch (_labor.CalcOnId) {
                    case 61:
                        _labor.LabourAmount = _labor.LabourRate * Pieces;
                        break;
                    case 62:
                        _labor.LabourAmount = _labor.LabourRate * NetWeight;
                        break;
                    case 63:
                        _labor.LabourAmount = _labor.LabourRate * Weight;
                        break;
                }
                labordetails[i] = _labor;
                newlaboramount += _labor.LabourAmount;
            }
        }
        BOMDetails = bomdetails;
        let UnitLabour = newlaboramount > 0 ? newlaboramount : totallaboramount;
        let UnitRate = newstoneamount > 0 ? newstoneamount : totalstoneamount + totalmetalamount;

        let UnitCost = UnitRate + UnitLabour;
        let NetAmount = UnitRate;
        let GrossAmount = 0;
        let SplitLabor = q.ToBool(GetConfigValue(1033)); 
        if (Pieces != null) {
            if (SplitLabor)
                GrossAmount = (Pieces * NetAmount) + UnitLabour + FancyCharges + OtherCharges;
            else
                GrossAmount = (Pieces * NetAmount) + newlaboramount;
        }
        let item: Retail.POSSalesItemsRow = {
            BOMDetails: BOMDetails,
            LaborDetails: labordetails,
            UnitLabour: UnitLabour,
            UnitRate: UnitRate,
            UnitCost: UnitCost,
            NetAmount: NetAmount,
            GrossAmount: GrossAmount
        }
        return item;
    }

   

}